Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.RouteDivisionCheckBox = function () {
  this.entity = null;
  this.selector = null;
  this.screenName = null;
  this.valueBtn = null;
  this.id = "buttonEventCheckBox";
  this.className = "";
  this.disabled = false;
  this.label = null;

  this.setEntity = function (entity) {
    this.entity = entity;
  };

  this.setLabel = function (label) {
    this.label = label;
  };

  this.setSelector = function (selector) {
    this.selector = selector;
  };

  this.setScreenName = function (screenName) {
    this.screenName = screenName;
  };

  this.setValueBtn = function () {
    this.valueBtn = "";
  };

  this.setBtnSelector = function (btnSelector) {
    this.btnSelector = btnSelector;
  };

  this.setId = function (id) {
    this.id = id;
  };

  this.setClassName = function (className) {
    this.className = className;
  };

  this.setDisabled = function (disabled) {
    this.disabled = disabled;
  };

  this.checkElementAndWriteHTML = function (selector, html) {
    if (selector !== null) {
      const buttonsContainerSelector = `${selector} .MonetUIGridActions`;
      const buttonsContainer = $(buttonsContainerSelector);

      $(buttonsContainerSelector).append(html);
    }
  };

  this.createBtn = function () {
    try {
      const div = document.createElement("div");
      const checkbox = document.createElement("input");
      const label = document.createElement("label");
      const resource = Monet.I18n.getResourcesByKey(this.label);

      div.setAttribute("class", "eventCheckBox gridActionDiv");

      checkbox.setAttribute("type", "checkbox");
      checkbox.setAttribute("id", this.id);
      checkbox.setAttribute("class", `button ${this.className}`);

      label.setAttribute("for", this.id);
      label.setAttribute("class", "eventCheckBoxLabel");
      label.innerText = resource;

      div.appendChild(checkbox);
      div.appendChild(label);

      this.checkElementAndWriteHTML(this.selector, div);
    } catch (e) {
      new Monet.Exception.ReturnError(
        this,
        "Error on create button",
        e
      ).console();
    }
  };

  this.init = function () {
    this.createBtn();
  };

  return this;
};
